import React, { Component } from 'react';
import { Container, Button, Badge, Alert, Form, Row, Col } from 'react-bootstrap';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import Navigation from "context/nav";

export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modifying: false,
      updating: false,
      updatingError: null,
      profile: {
        tags: this.props.blob.tags || []
      }
    };
    if ( this.props.blob.name ) {
      this.state.profile.name = this.props.blob.name;
    }
    if ( this.props.blob.url ) {
      this.state.profile.url = this.props.blob.url;
    }
    if ( this.props.blob.description ) {
      this.state.profile.description = this.props.blob.description;
    }

    this.form = React.createRef();
  }

  handleUpdate = () => {
    // Check form validity
    if ( !this.form.current.reportValidity() ) {
      return;
    }

    this.setState({
      modifying: true,
      updating: true,
      updatingError: null
    });

    // Update blob profile
    const orgId = this.props.blob.org_id;
    const blobId = this.props.blob.id;
    this.props.app.api.blobsIdPatch(orgId, blobId, this.state.profile)
      .then(response => {
        this.setState({
          modifying: false,
          updating: false,
          updatingError: null
        });

        // Trigger blob refresh upon visibility change
        this.props.blobInterface.loadBlob();
      }, error => {
        // Indicate error
        this.setState({
          modifying: false,
          updating: false,
          updatingError: error.message
        });
      });
  }

  handleTagsChange = (tags) => {
    let profile = this.state.profile;
    profile.tags = tags;
    this.setState({profile: profile});
  }

  render() {
    return (
      <>
        <h5>Profile</h5>
        <hr/>

        <Form ref={this.form}>
          <Form.Group>
            <Form.Label>
              <strong>Blob Alias</strong>
            </Form.Label>
            <Row>
              <Col>
                {this.props.blob.alias}
              </Col>
            </Row>
          </Form.Group>

          <Form.Group>
            <Form.Label>
              <strong>Data</strong>
            </Form.Label>
            <Row>
              <Col>
                <div className="blob-item-row">
                  Domain: <Badge variant="secondary" className="title-tag-badge">{this.props.blob.domain}</Badge>
                  &nbsp;
                  Type: <Badge variant="secondary" className="title-tag-badge">{this.props.blob.type}</Badge>
                  &nbsp;
                  Format: <Badge variant="secondary" className="title-tag-badge">{this.props.blob.format}</Badge>
                </div>
              </Col>
            </Row>
          </Form.Group>

          <Form.Group>
            <Form.Label>
              <strong>Name</strong>
            </Form.Label>
            <Row>
              <Col sm={6}>
                <Form.Control
                  type="text" size="sm" autoFocus
                  disabled={this.props.readOnly}
                  value={this.state.profile.name}
                  onChange={(event) => {
                    let profile = this.state.profile;
                    profile.name = event.target.value;
                    this.setState({profile: profile});
                  }}
                />
              </Col>
            </Row>
            <Form.Text muted>
              Name that suits this blob best.
            </Form.Text>
          </Form.Group>

         <Form.Group>
            <Form.Label>
              <strong>Url</strong>
            </Form.Label>
            <Row>
              <Col sm={6}>
                <Form.Control
                  type="text" size="sm"
                  disabled={this.props.readOnly}
                  value={this.state.profile.url}
                  onChange={(event) => {
                    let profile = this.state.profile;
                    profile.url = event.target.value;
                    this.setState({profile: profile});
                  }}
                />
              </Col>
            </Row>
            <Form.Text muted>
              Reference to blob external profile.
            </Form.Text>
          </Form.Group>

          <Form.Group>
            <Form.Label>
              <strong>Description</strong>
            </Form.Label>
            <Row>
              <Col sm={9}>
                <Form.Control
                  type="text" size="sm"
                  disabled={this.props.readOnly}
                  value={this.state.profile.description}
                  onChange={(event) => {
                    let profile = this.state.profile;
                    profile.description = event.target.value;
                    this.setState({profile: profile});
                  }}
                />
              </Col>
            </Row>
            <Form.Text muted>
              Brief overview of data stored in this blob.
            </Form.Text>
          </Form.Group>

          <Form.Group>
            <Form.Label>
              <strong>Tags</strong>
            </Form.Label>
            <Row>
              <Col sm={6}>
                <TagsInput
                  value={this.state.profile.tags}
                  onChange={this.handleTagsChange}
                  disabled={this.props.readOnly}
                />
              </Col>
            </Row>
            <Form.Text muted>
              The list of tags describing this blob. <br/>
              Only alphanumeric characters along with <strong>-</strong>,<strong>_</strong> are allowed.
            </Form.Text>
          </Form.Group>

          {this.state.updating &&
            <div>
              <Alert variant="primary">
                Updating blob profile...
              </Alert>
            </div>
          }
          {this.state.updatingError &&
            <div className="content-row-bottom">
              <Alert variant="warning">
                {this.state.updatingError}
              </Alert>
            </div>
          }
          {!this.state.modifying && !this.props.readOnly &&
            <div>
              <Button
                variant="success"
                size="sm"
                onClick={this.handleUpdate}>
                Update
              </Button>
            </div>
          }
        </Form>
      </>
    );
  }
}
